// react-native-webview renders "does not support this platform" on web (RNW has
// no WebView). Shim it to a real <iframe> so WebView screens (Privacy Policy,
// Return Policy, in-app web content) render. Supports source={{uri}} and
// source={{html}}; maps onLoadEnd/onLoad. Aliased via react-native-webview$ in
// webpack.web.config.js. (Cross-origin pages that send X-Frame-Options/CSP
// frame-ancestors may still refuse to frame — that's the target's policy.)
const React = require("react");
const View = require("react-native-web/dist/exports/View").default;

function WebView(props) {
  const {
    source = {},
    style,
    onLoad,
    onLoadEnd,
    onError, // eslint-disable-line no-unused-vars
    // drop RN-only props that aren't valid DOM attrs
    injectedJavaScript, onMessage, onLoadStart, onNavigationStateChange,
    startInLoadingState, scalesPageToFit, javaScriptEnabled, domStorageEnabled,
    originWhitelist, ...rest // eslint-disable-line no-unused-vars
  } = props || {};
  const iframeProps = {
    title: "webview",
    style: { border: "0", width: "100%", height: "100%", flexGrow: 1 },
    onLoad: onLoadEnd || onLoad,
  };
  if (source && source.uri) {
    // Absolute URLs (e.g. https://citymall.live/privacy-policy) send
    // X-Frame-Options and refuse to frame — route them through the devserver
    // /frame proxy (same-origin, framing headers stripped). Relative/proxy uris
    // are already same-origin, load as-is.
    iframeProps.src = /^https?:\/\//.test(source.uri)
      ? "/frame?url=" + encodeURIComponent(source.uri)
      : source.uri;
  } else if (source && source.html) iframeProps.srcDoc = source.html;
  return React.createElement(
    View,
    { style: [{ flex: 1 }, style] },
    React.createElement("iframe", iframeProps),
  );
}

module.exports = { __esModule: true, WebView, default: WebView };
